export { Timestamp } from './Timestamp';
export type { TimestampProps, TimestampSlots, TimestampState } from './Timestamp.types';
export { timestampClassNames, useTimestampStyles_unstable } from './useTimestampStyles.styles';
